import React from 'react'
import Navbar from './Navbar'

export default function UserList() {
  return (
    <div>
       <Navbar/> 
        UserList
    </div>
  )
}
